






































import {Component, Vue} from "vue-property-decorator";
import {Button, Dialog, Toast, Switch} from "vant";
import customField from "@/components/customField/index.vue";
import {login} from "@/utils/hybirdMethods";

import {getBrowser} from "@/utils/browser";
import {goBack} from "@/utils/hybirdMethods";
import axios from "axios";

const browser = getBrowser();

@Component({
  components: {
    [Button.name]: Button,
    [customField.name]: customField,
    [Switch.name]: Switch,
  }
})
export default class Login extends Vue {
  orderConfirmationChecked = false;
  cancellationConfirmationChecked = false;
  form = {
    content: "",
    isShow: false
  };
  tradeSettingsBoxShow = false;

  created() {
    // this.getAvailablerAtio();

    // this.getTradeSettings().then(()=>{
    //   this.tradeSettingsBoxShow = true;
    // });
    this.getTradeSettings();
	Toast.resetDefaultOptions();
  }


  inputChange() {
    this.form.isShow = true;
  }

  getAvailablerAtio() {
    (this as any).$apis
        .getAvailablerAtioAPI()
        .then(res => {
          
          this.form.content = (Number(res.data.data.availableRatio) * 100) + "";
        })
        .catch(e => {
          
        });
  }

  setAvailablerAtio() {
    var count = Number(this.form.content);
    if (count > 100 || count <= 0) {
      Toast("比例应该在 [1-100] 内");
      return;
    }

    var availableRatioStr = Number(this.form.content) / 100 + "";

    const params = {
      availableRatio: availableRatioStr,
    };
    

    (this as any).$apis
        .setAvailablerAtioAPI(params)
        .then(res => {
          Toast("设置成功");
          this.form.isShow = false;
        })
        .catch(e => {
          
        });
  }

  // 获取用户的交易设置
  getTradeSettings() {
    
    return (this as any).$apis
        .getTransactionSettingList({})
        .then(res => {
          
          this.orderConfirmationChecked = Boolean(res.create_order);
          this.cancellationConfirmationChecked = Boolean(res.cancel_order);
          this.tradeSettingsBoxShow = true;
        })
        .catch(e => {
          
        });
    // let res = (this as any).$localstorage.get("openObj")
    // this.orderConfirmationChecked = Boolean(res.create_order);
    // this.cancellationConfirmationChecked = Boolean(res.cancel_order);
    // this.tradeSettingsBoxShow = true;
  }
  //  设置 用户的交易设置
  setTradeSetting() {
    // 下单确认
    let createOrder = Number(this.orderConfirmationChecked);
    // 撤单确认
    let cancelOrder = Number(this.cancellationConfirmationChecked);
    // 改单确认
    // let updateOrder = '';
    (this as any).$apis
        .setTransactionSetting({
          create_order: createOrder,
          cancel_order: cancelOrder
        })
        .then(res => {
		  let obj = (this as any).$localstorage.get("openObj");
		  obj.create_order = createOrder;
		  obj.cancel_order = cancelOrder;
		  (this as any).$localstorage.set("openObj",obj);
          
        })
        .catch(e => {
          
        });
  }

  // 设置用户的 下单确认
  setOrderConfirmation(value) {
    
    this.setTradeSetting();
  }

  // 设置用户的 撤单确认
  setCancellationConfirmation(value) {
    
    this.setTradeSetting();
  }

  openFuturesSetup(){
    
    this.$router.push({path:'/h5-page-futures-setup'})
  }
}
